import React from 'react';
import PropTypes from 'prop-types';

export default function Pagination({ totalPages, currentPage, onPageChanged }) {
  const neighboursPage = 2;
  const fullPagination = totalPages > 5;
  const firstPage = 1;
  const lastPage = totalPages;
  const renderedPages = [];

  // Go first page button.
  if (fullPagination) {
    renderedPages.push(
      // eslint-disable-next-line jsx-a11y/control-has-associated-label
      <button
        key="go-first"
        type="button"
        className={
          currentPage <= 1
            ? 'search-page__filter-page search-page__icon-post disabled'
            : 'search-page__filter-page search-page__icon-post'
        }
        disabled={currentPage <= 1 ? true : null}
        onClick={() => {
          onPageChanged(firstPage);
        }}
      />,
    );
  }

  // Previous page button.
  renderedPages.push(
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <button
      key="prev"
      type="button"
      className={
        currentPage <= 1
          ? 'search-page__filter-page search-page__icon-back disabled'
          : 'search-page__filter-page search-page__icon-back'
      }
      disabled={currentPage <= 1 ? true : null}
      onClick={() => {
        onPageChanged(currentPage - 1);
      }}
    />,
  );

  // eslint-disable-next-line no-plusplus
  for (let index = 1; index <= totalPages; index++) {
    if (index < currentPage && index >= currentPage - neighboursPage) {
      if (index === currentPage - neighboursPage && index - 1 >= firstPage) {
        // First page.
        renderedPages.push(
          <button
            key="first"
            type="button"
            className="search-page__filter-page search-page__page-number"
            onClick={() => {
              onPageChanged(firstPage);
            }}
          >
            {firstPage}
          </button>,
        );
        // Ellipsis button.
        renderedPages.push(
          <button
            key="ellipsis-first"
            type="button"
            className="search-page__filter-page search-page__ellipsis-button disabled"
            disabled
          >
            ...
          </button>,
        );
      }
      renderedPages.push(
        <button
          key={index}
          type="button"
          className="search-page__filter-page search-page__page-number"
          onClick={() => {
            onPageChanged(index);
          }}
        >
          {index}
        </button>,
      );
    } else if (index === currentPage) {
      renderedPages.push(
        <button
          key={index}
          type="button"
          className="search-page__filter-page search-page__page-number search-page__current-page"
          onClick={() => {
            onPageChanged(index);
          }}
        >
          {index}
        </button>,
      );
    } else if (index > currentPage && index <= currentPage + neighboursPage) {
      renderedPages.push(
        <button
          key={index}
          type="button"
          className="search-page__filter-page search-page__page-number"
          onClick={() => {
            onPageChanged(index);
          }}
        >
          {index}
        </button>,
      );
      if (index === currentPage + neighboursPage && index <= totalPages) {
        // Ellipsis button.
        renderedPages.push(
          <button
            key="ellipsis-last"
            type="button"
            className="search-page__filter-page search-page__ellipsis-button disabled"
            disabled
          >
            ...
          </button>,
        );
        // Last page button.
        renderedPages.push(
          <button
            key="last"
            type="button"
            className="search-page__filter-page search-page__page-number"
            onClick={() => {
              onPageChanged(lastPage);
            }}
          >
            {lastPage}
          </button>,
        );
      }
    }
  }

  // Next page button.
  renderedPages.push(
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <button
      key="next"
      type="button"
      className={
        currentPage >= totalPages
          ? 'search-page__filter-page search-page__icon-next disabled'
          : 'search-page__filter-page search-page__icon-next'
      }
      disabled={currentPage >= totalPages ? true : null}
      onClick={() => {
        onPageChanged(currentPage + 1);
      }}
    />,
  );

  // Go last page button.
  if (fullPagination) {
    renderedPages.push(
      // eslint-disable-next-line jsx-a11y/control-has-associated-label
      <button
        key="go-last"
        type="button"
        className={
          currentPage >= totalPages
            ? 'search-page__filter-page search-page__icon-prev disabled'
            : 'search-page__filter-page search-page__icon-prev'
        }
        disabled={currentPage >= totalPages ? true : null}
        onClick={() => {
          onPageChanged(lastPage);
        }}
      />,
    );
  }

  return (
    <div className="search-page__pagination">
      <div className="search-page__filter-pagination">{renderedPages}</div>
    </div>
  );
}

Pagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChanged: PropTypes.func.isRequired,
};
